var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"routes":[
            { name: 'Admin Resellers', label: _vm.$translate.text('general.dashboard') },
            { name: 'Admin Profiles', label: _vm.$translate.text('general.profiles') },
            { name: 'Admin Payments', label: _vm.$translate.text('general.payments') },
            { name: 'Admin Requests', label: _vm.$translate.text('general.requests') }
        ],"profileRoutes":[
            { name: 'Account', label: _vm.$translate.text('auth.my_account') },
            { name: 'Logout', label: _vm.$translate.text('auth.logout') }
        ],"name":"admin"}}),_c('router-view'),_c('Footer',{attrs:{"routes":[
            { name: 'General About Us', label: _vm.$translate.text('nav.footer.about') },
            { name: 'General Conditions', label: _vm.$translate.text('nav.footer.conditions') },
            { name: 'General faq', label: _vm.$translate.text('nav.footer.help') },
            { name: 'General Contact Us', label: _vm.$translate.text('nav.footer.contact') }
        ],"name":"admin","showLoggedIn":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }